module.exports = __webpack_public_path__ + "static/img/Mid-Autumnmenu6-8.68a14cd.jpg";